/* eslint-disable @typescript-eslint/no-explicit-any */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timer',
})
export class TimerPipe implements PipeTransform {
  transform(value: number, _args?: any): any {
    return `${Math.floor(value / 60)}:${('0' + (value % 60).toString()).slice(-2)}`;
  }
}
